import useTooltipContext from './useTooltipContext';

export type Props = {
  x: number;
  y: number;
  width: number;
  height: number;
};

/**
 * This reports its ref to the tooltip context so that the tooltip can be
 * automatically constrained to the dimensions of a specific set of bounds within the chart.
 */
const TooltipBoundsRect = ({ width, height, x, y }: Props) => {
  const { setBoundsRef } = useTooltipContext();

  return (
    <rect
      data-testid="tooltip-bounds-rect"
      ref={setBoundsRef}
      fill="none"
      stroke="none"
      pointerEvents="none"
      width={Math.max(width, 0)}
      height={Math.max(height, 0)}
      x={x}
      y={y}
    />
  );
};

export default TooltipBoundsRect;
